import { render, staticRenderFns } from "./EditorNewAssignmentModal.vue?vue&type=template&id=214d0db1&scoped=true&"
import script from "./EditorNewAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./EditorNewAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d0db1",
  null
  
)

export default component.exports